export const COLUMN_SORT_STATES = {
  none: 0,
  asc: 1,
  desc: 2,
}
